import { render, staticRenderFns } from "./errornotfound-component.vue?vue&type=template&id=573f3225"
import script from "./errornotfound-component.vue?vue&type=script&lang=ts"
export * from "./errornotfound-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports